<template>
  <div>
    <v-alert border="top" color="green darken-1" dark>
      Сумма оплаты клиентом по УПД<br />(к получению):
      <span class="text-h6">{{ updSum }}</span> руб.
    </v-alert>
    <v-card class="mx-auto" max-width="auto">
      <v-card-text>
        <v-text-field
          v-model="clientSum"
          name="number"
          label="Получено от клиента в рублях:"
          type="text"
          clearable
          :rules="[rules.numberRule, rules.maxRule]"
        ></v-text-field>

        <p class="text-h5 text--primary" v-if="this.changeSum > 0">
          Сдача:
          <span class="text-h6"
            ><span class="brg-mark">{{ changeSum }} </span> руб</span
          >
        </p>

        <span class="caption"
          >Нажмите на эту кнопку, если вы выдаете наличные деньги клиенту и ему
          будет отправлен чек на сумму по УПД:</span
        >
        <v-btn block @click="onSendCheck" class="goods-link">
          <v-icon dark>mdi-rocket-launch</v-icon>
          Чек на сумму {{ updSum }} <span class="currency-rub"></span>
        </v-btn>

        <span class="caption"
          >Будет сформировано 2 чека: первый на сумму УПД и второй на сумму
          сдачи (аванс):</span
        >
        <v-btn
          block
          :disabled="changeSum <= 0"
          class="goods-link"
          @click="onSendDoubleCheck"
        >
          <v-icon dark>mdi-rocket-launch</v-icon>
          Чеки на сумму {{ updSum }} и {{ changeSum }}
          <span class="currency-rub"></span>
        </v-btn>

        <v-row align="center" justify="space-around">
          <v-card-actions>
            <v-btn class="readmore-link" color="white" @click="onGoBack">
              <v-icon dark> mdi-arrow-u-left-bottom </v-icon>
              Назад
            </v-btn>
          </v-card-actions>
        </v-row>
      </v-card-text>
    </v-card>
    <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
  </div>
</template>

<script>
import ConfirmDialogue from "@/components/ConfirmDialogue.vue";
export const MAX_PREPAID_SUM = 100000;

export default {
  name: "CorrectSum",
  components: { ConfirmDialogue },
  props: ["updSum", "upd"],
  data: () => ({
    createPrepaid: false,
    clientSum: "",
    rules: {
      numberRule: (v) => {
        if (!v.trim()) return true;
        if (!isNaN(parseFloat(v)) && v >= 0) return true;
        return "Введите число";
      },
      maxRule: (v) => {
        if (!v.trim()) return true;
        if (parseFloat(v) <= MAX_PREPAID_SUM) return true;
        return "Сумма аванса не должна превышать 100 000 руб.";
      },
    },
  }),
  computed: {
    hasBeenCorrect() {
      let canceled = this.$store.getters.getcanceledGoods;
      return canceled.length > 0;
    },
    changeSum() {
      let sum =
        this.clientSum == 0 || this.clientSum > MAX_PREPAID_SUM
          ? 0
          : parseFloat(this.clientSum - this.updSum).toFixed(2);
      return sum > 0 ? sum : 0;
    },
    isCreated() {
      return this.$store.getters.isCreated;
    },
    isPrepaidCreated() {
      return this.$store.getters.isPrepaidCreated;
    },
  },
  watch: {
    isCreated: {
      handler(newValue, oldValue) {
        if (
          newValue !== oldValue &&
          newValue === true &&
          this.createPrepaid === true &&
          this.changeSum > 0 &&
          this.isPrepaidCreated === false
        ) {
          let successMessage =
            "Чеки на суммы " +
            this.$store.getters.updSum +
            " руб и " +
            this.changeSum +
            " руб успешно сформированы";
          this.onConfirmedSendCheck(
            this.changeSum,
            true,
            false,
            successMessage,
            "Чеки сформированы"
          );
        }
      },
      deep: true,
    },
  },
  methods: {
    onConfirmCorrectChanges() {
      if (this.hasBeenCorrect) {
        this.loading = true;
        this.$store
          .dispatch("ukd_goods", {
            updSearchNumber: this.$store.getters.searchNumber,
            ukdGoods: this.$store.getters.getcanceledGoods,
          })
          .then(() => {
            this.loading = false;
            this.dialog = true;
            this.dialogTitle = "Успешно";
            this.dialogMessage = "Корректировка УПД отправлена";
            this.dialogError = false;
          })
          .catch((err) => {
            this.dialogError = true;
            this.dialog = true;
            this.dialogTitle = "УКД не сформирована";
            let error = JSON.parse(err.request.responseText);
            this.dialogMessage = error.message;
            this.loading = false;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    onGoBack() {
      this.$refs.confirmDialogue
        .show({
          title: "Покинуть страницу",
          message: "Вернуться назад?",
          okButton: "Да",
          showEmail: false,
        })
        .then((result) => {
          if (result) {
            this.$store.commit("finishCorrectSum");
          }
        });
    },
    onSendCheck() {
      this.$refs.confirmDialogue
        .show({
          title: "Отправить чек",
          message: "Чек на сумму",
          item: this.$store.getters.updSum + " руб",
          okButton: "Отправить",
          showEmail: true,
          email: this.upd.contractor.email,
        })
        .then((result) => {
          if (result) {
            this.createPrepaid = false;
            this.onConfirmedSendCheck(this.$store.getters.updSum);
          }
        });
    },
    onSendDoubleCheck() {
      this.$refs.confirmDialogue
        .show({
          title: "Отправить чеки",
          message: "Чеки на сумму УПД и аванса",
          item:
            this.$store.getters.updSum +
            " руб" +
            " + " +
            this.changeSum +
            " руб.",
          okButton: "Отправить",
          showEmail: true,
          email: this.upd.contractor.email,
        })
        .then((result) => {
          if (result) {
            this.createPrepaid = true;
            this.onConfirmedSendCheck(this.$store.getters.updSum, false, true);
          }
        });
    },
    onConfirmedSendCheck(
      checkSum,
      is_prepaid = false,
      quiet = false,
      successMessage = null,
      successTitle = "Чек сформирован"
    ) {
      this.onConfirmCorrectChanges();
      this.fillCheck(checkSum, is_prepaid);
      this.$emit("sendCheck", quiet, successMessage, successTitle);
    },
    fillCheck(checkSum, is_prepaid = false) {
      let check = {
        checkExtid: this.$uuid.v4(),
        contractExtid: this.upd.contractor.contract.id,
        contractNumber: this.upd.contractor.contract.number,
        contractorName: this.upd.contractor.name,
        deliveryAddress: this.upd.deliveryAddress.name,
        transporterExtid: this.upd.transporterExtid,
        updExtid: is_prepaid ? null : this.upd.docId.toString(),
        updNumber: is_prepaid ? null : this.upd.docNumber,
        amount: checkSum.toString(),
        email: this.$store.getters.getContractorEmail,
        isPrepaid: is_prepaid,
        upd: this.upd,
      };
      this.$store.commit("fillCheckToSend", check);
      this.$store.commit("updateCheckSum", parseFloat(checkSum));
    },
  },
};
</script>
